/* Keep crowded waypoint icons small without replacing their interactive markers. */
L.Routing.WaypointMarkers = L.Layer.extend({
    initialize: function(plan) {
        this._plan = plan;
    },

    onAdd: function(map) {
        this._map = map;
        map.on('zoomend', this._update, this);
        map.on('layeradd layerremove', this._scheduleUpdate, this);
        this._plan.on('waypointschanged waypointdrag', this._update, this);
        this._update();
    },

    onRemove: function(map) {
        map.off('zoomend', this._update, this);
        map.off('layeradd layerremove', this._scheduleUpdate, this);
        this._plan.off('waypointschanged waypointdrag', this._update, this);
        L.Util.cancelAnimFrame(this._frame);
        (this._plan._markers || []).forEach(function(marker) {
            var icon = marker && marker.getElement();
            if (icon) L.DomUtil.removeClass(icon, 'waypoint-compact');
        });
    },

    _scheduleUpdate: function(e) {
        if (!(e.layer instanceof L.Marker)) return;
        L.Util.cancelAnimFrame(this._frame);
        this._frame = L.Util.requestAnimFrame(this._update, this);
    },

    _update: function() {
        var map = this._map;
        var markers = (this._plan._markers || []).filter(function(marker) {
            return marker && marker.getElement();
        });
        // The plan stores markers in reverse waypoint order. Reserve space for
        // both endpoints first, then prefer earlier intermediate waypoints.
        var reserved = [];
        var intermediate = [];
        markers.slice().reverse().forEach(function(marker) {
            var icon = marker.getElement();
            var point = map.latLngToLayerPoint(marker.getLatLng());
            if (L.DomUtil.hasClass(icon, 'custom-marker')) {
                intermediate.push({ icon: icon, point: point });
            } else {
                reserved.push(point);
            }
        });
        intermediate.forEach(function(item) {
            // Icons are 20px wide; allow a 4px gap between numbered markers.
            var crowded = reserved.some(function(point) {
                return Math.abs(point.x - item.point.x) < 24 &&
                    Math.abs(point.y - item.point.y) < 24;
            });
            L.DomUtil[crowded ? 'addClass' : 'removeClass'](item.icon, 'waypoint-compact');
            if (!crowded) reserved.push(item.point);
        });
        map.fire('waypointmarkerschanged');
    }
});
